import { render, staticRenderFns } from "./CardReportTemp.vue?vue&type=template&id=f8876a66&scoped=true"
import script from "./CardReportTemp.vue?vue&type=script&lang=js"
export * from "./CardReportTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8876a66",
  null
  
)

export default component.exports